import { render } from "./ViewWhatsAppInstance.vue?vue&type=template&id=a0b08dd6&scoped=true"
import script from "./ViewWhatsAppInstance.vue?vue&type=script&lang=js"
export * from "./ViewWhatsAppInstance.vue?vue&type=script&lang=js"

import "./ViewWhatsAppInstance.vue?vue&type=style&index=0&id=a0b08dd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b08dd6"]])

export default __exports__